import {
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import type { Props } from './types';
import messages from '../messages';

function CanceledDetail({ intl, isDenied }: Props) {
  return (
    <Stack spacing={1} padding={2} paddingRight={6}>
      <Typography variant="titleSmall">
        {intl.formatMessage(messages.canceled)}
      </Typography>
      <Stack spacing={1}>
        <Typography variant="bodySmall">
          {intl.formatMessage(
            messages[isDenied ? 'deniedDetail' : 'canceledDetail'],
          )}
        </Typography>
      </Stack>
    </Stack>
  );
}

export default CanceledDetail;
